export default class SubCategoriaModel {
  constructor () {
    this.nome = null
    this.inactive = null
    this.categoriaId = null
  }
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/subcategoriamodel.js